import { FC } from 'react';

import { SortingDirection } from 'constants/enums';

import DataTable from 'components/DataTable/DataTable';
import { FilterBar } from 'components/FilterBar/FilterBar';
import FirstActionModal from 'components/FirstActionModal/FirstActionModal';

import { NO_DATA_MESSAGES } from './consts';
import { StyledBlockedPlayersTable } from './style';
import { useBlockedPlayersTable } from './useBlockedPlayersTable';
import { blockedPlayersUtils } from './utils';

export const BlockedPlayersTable: FC = () => {
  const {
    page,
    setPage,
    pageSize,
    rows,
    filters,
    sorting,
    isLoading,
    isError,
    isNoDataAvailable,
    totalCount,
    searchByPlayerIdValue,
    setSearchByPlayerIdValue,
    handleClearFilters,
    handleSortModelChange,
    handleRowsPerPageChange,
  } = useBlockedPlayersTable();

  return (
    <StyledBlockedPlayersTable>
      <FilterBar
        filters={filters}
        handleClearFilters={handleClearFilters}
        searchByKeyPlaceholder="Search with player ID"
        searchByKeyValue={searchByPlayerIdValue}
        onSearchByKeyChange={setSearchByPlayerIdValue}
      />
      <DataTable
        columns={blockedPlayersUtils.blockedPlayersColumns}
        rows={rows}
        loading={isLoading}
        error={isError}
        pagination
        hideFooter={false}
        pageSize={pageSize}
        currentPage={page}
        totalCount={totalCount}
        onPageChange={setPage}
        onRowsPerPageChange={handleRowsPerPageChange}
        initialSorting={{
          sortModel: [
            {
              field: sorting.sortValue,
              sort: sorting.direction === SortingDirection.ASC ? SortingDirection.ASC : SortingDirection.DESC,
            },
          ],
        }}
        onSortModelChange={handleSortModelChange}
        onNoData={
          <FirstActionModal
            {...(isNoDataAvailable ? NO_DATA_MESSAGES.empty : NO_DATA_MESSAGES.noResults)}
          />
        }
      />
    </StyledBlockedPlayersTable>
  );
};
